import { getHistoricalDataSimplified } from "@/_core/data/api_calls/candle_data/getHistoricalData";
import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves historical data for commodities and then process today's data
 * @param {object} _this: context variables
 * @param {object} assetExtraParams: Contains commodity information related
 */
export function getCommoditiesData(_this, assetExtraParams) {
  const variables = {
    format: "json",
    observation_date: formatDate_YMDHMS(roundDateToFloor(_this.initCommodityDate)),
    commodity: assetExtraParams.commodityNumber,
    contract: assetExtraParams.contract,
    contract_month_year: assetExtraParams.contract_month_year,
  };
  return getHistoricalDataSimplified(_this, {
    fetch: gatewayService.commodities.history,
    variables
  });
}
